module.exports = __webpack_public_path__ + "media/promo/panasonic/images/buy-4-e9d4a7affd4993983b49c42af81d9e73.png";